import React from 'react';
import PageContainer from 'components/layout/PageContainer';
import TutorialPage from 'core/views/TutorialPage';
import { TITLES } from 'constants/pagesTitles';

const Tutorial = () => (
  <PageContainer title={TITLES.tutorial} isImgBg>
    <TutorialPage />
  </PageContainer>
);

export default Tutorial;
